<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">新增车牌</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()"/>
    </div>
    <!-- 返回 结束 -->
    <!-- 新增车牌banner 开始 -->
    <div class="page_top" >
      <!-- @click="scanMesg()" <img class="caradd_bannerimg" src="/static/carsaoma.png" /> -->
    </div>
    <!-- 新增车牌banner 结束 -->
    <!-- 行驶证正面 开始 -->
    <div class="carlicenseadd-upimgbox11">
      <div v-if="showmain" class="carlicenseadd-upimgbox1">
        <img class="carlicenseadd-upimg" src="/static/mainImg.png" />
      </div>
      <div v-else class="carlicenseadd-upimgbox1">
        <img :src="drivingLicenseMain" alt="" class="carlicenseadd-upimg1">
      </div>
      <input type="file" class="fileinput" accept="image/*" @change='getimgmain($event)' />
    </div>
    <!-- 行驶证正面 结束 -->
    <!-- 行驶证背面 开始 -->
    <div class="carlicenseadd-upimgbox">
      <div v-if="showvice" class="carlicenseadd-upimgbox1">
        <img class="carlicenseadd-upimg" src="/static/viceImg.png" />
      </div>
      <div v-else class="carlicenseadd-upimgbox1">
        <img :src="drivingLicenseVice" alt="" class="carlicenseadd-upimg1">
      </div>
      <input type="file" class="fileinput" accept="image/*" @change='getimgvice($event)' />
    </div>
    <!-- 行驶证背面 结束 -->
    <!-- 新增车牌表单  开始 -->
    <div class="page_taocan carlicenseadd_taocan">
      <div class="page_inputfrom carlicenseadd_input1">
        <div class="carlicenseadd_checktitle"><span class="bitian">*</span>车牌号码:</div>
        <input class="page_checkinput carlicenseadd_checkinput" placeholder="请输入车牌号码" v-model="car_no" />
      </div>
      <div class="page_inputfrom carlicenseadd_input">
        <div class="carlicenseadd_checktitle"><span class="bitian">*</span>所有人:</div>
        <input class="page_checkinput carlicenseadd_checkinput" placeholder="请输入所有人" v-model="owner" />
      </div>
      <div class="page_inputfrom carlicenseadd_input">
        <div class="carlicenseadd_checktitle"><span class="bitian">*</span>品牌车型:</div>
        <input class="page_checkinput carlicenseadd_checkinput" placeholder="请输入品牌车型" v-model="model" />
      </div>
      <div class="page_inputfrom carlicenseadd_input">
        <div class="carlicenseadd_checktitle"><span class="bitian">*</span>车辆识别代号:</div>
        <input class="page_checkinput carlicenseadd_checkinput" placeholder="请输入车辆识别代号" v-model="vin" />
      </div>
      <div class="page_inputfrom carlicenseadd_input">
        <div class="carlicenseadd_checktitle"><span class="bitian">*</span>发动机号:</div>
        <input class="page_checkinput carlicenseadd_checkinput" placeholder="请输入发动机号" v-model="engineNo" />
      </div>
      <div class="page_inputfrom carlicenseadd_input">
        <div class="carlicenseadd_checktitle"><span class="bitian">*</span>核定载人数:</div>
        <input class="page_checkinput carlicenseadd_checkinput" placeholder="请输入核定载人数" v-model="mannedNums" />
      </div>
      <div class="page_inputfrom carlicenseadd_input" @click="openTime()">
        <div class="carlicenseadd_checktitle"><span class="bitian">*</span>注册时间:</div>
        <div :class="isregisterDate ? 'carlicenseadd_checkinput' : 'carlicenseadd_checkinput1'">{{registerDate}}</div>
      </div>
      <div class="page_inputfrom carlicenseadd_input" @click="openEndTime()">
        <div class="carlicenseadd_checktitle"><span class="bitian">*</span>发证日期:</div>
        <!-- <input class="page_checkinput carlicenseadd_checkinput" placeholder="请输入检验有效期" v-model="issueDate" /> -->
        <div :class="checkissueDate ? 'carlicenseadd_checkinput' : 'carlicenseadd_checkinput1'">{{issueDate}}</div>
      </div>
    </div>
    <!-- <div class="carlicenseadd-none"></div> -->

    <!-- 新增车牌表单  结束 -->
    <div class="page_mesg">
      <div class="page_mesgtitle">
        <img class="page_mesgimg" src="/static/newprojecticon/title.png" />
        <div class="page_mesgtext">注意事项</div>
      </div>
      <div class="page_mesgtip">所填信息为当地交管局查询所必需信息，我们将对您的信息严格保密，请放心填写。</div>
    </div>
    <!-- <div class="bottonnone"></div> -->
    <!-- 提交 开始 -->
    <div class="page_button carlicenseadd_button" @click="addCard()">
      <div class="page_zhifu">{{isedit!=0 ? '修改' : '添加'}}</div>
    </div>
    <!-- 提交 结束 -->
    <van-popup v-model="showStartdata" round position="bottom">
      <van-datetime-picker v-model="currentDate" type="date" @confirm="onConfirm" @cancel="onCancel" :min-date="minDate"
        :max-date="maxDate" />
    </van-popup>
    <van-popup v-model="showEndDate" round position="bottom">
      <van-datetime-picker v-model="currentDate" type="date" @confirm="onConfirm1" @cancel="onCancel1" :min-date="minDate"
        :max-date="maxDate" />
    </van-popup>
  </div>
</template>

<script>
  // import swal from 'sweetalert'
  import httper from '../../api/http'
  import {
    Dialog
  } from 'vant';
  import { Toast } from 'vant';
  export default {
    data() {
      return {
        id: "", // 上一页获取车信息id,默认为空
        car_no: '', // 车牌号码,默认为空
        brand: '', // 品牌,默认为空
        vehicle_type: '', // 车型,默认为空
        owner: "", //车主姓名
        model: "", //品牌车型
        vin: "", //车架号
        engineNo: "", //发动机号
        registerDate: "请选择注册日期", //注册日期
        isregisterDate:false,//是否选择日期
        issueDate: "请选择发证日期", //有效期
        checkissueDate:false,//是否选择发证日期
        mannedNums: "", //核定载人数
        drivingLicenseMain: "", //行驶证正面
        drivingLicenseVice: "", //行驶证副页
        extra: "", //正面扩展数据
        showTopTips: [{
          text: '请填写正确的车牌!',
          checked: false
        }], // 错误提示列表
        buttonClicked: false, // 防止支付重复点击,默认为false
        showmain: true,//是否展示正面行驶证背景图
        showvice: true,//是否展示背面行驶证背景图
        image: "",
        minDate: new Date(2000, 0, 1), //可选最小时间
        maxDate: new Date(2050, 10, 1), //可选最大时间
        currentDate: new Date(), //当前时间
       showStartdata: false, //开始时间选择弹框
       showEndDate: false, //结束时间选择弹框
       licenseItem:{},
       mainocr:"",//行驶证正面所有内容
       backocr:"",//行驶证背面所有内容
       isedit:0,//是否编辑
      }
    },
    created() {
      this.getwechat({
        url: location.href.split('#')[0]
      })
      console.log("isedit",parseInt(this.$route.query.isedit)!=0)
      if(parseInt(this.$route.query.isedit)!= 0){
        this.isedit = parseInt(this.$route.query.isedit)
        if (this.$route.query.licenseItem) {
          this.licenseItem = this.$route.query.licenseItem
          console.log(this.licenseItem)
          this.car_no = this.licenseItem.car_no
          this.owner = this.licenseItem.owner
          this.model= this.licenseItem.model
          this.vin= this.licenseItem.vin
          this.engineNo= this.licenseItem.engine_no
          this.registerDate= this.licenseItem.register_date
          this.issueDate= this.licenseItem.issue_date
          this.mannedNums= this.licenseItem.manned_nums
          this.drivingLicenseMain= this.licenseItem.driving_license_main
          this.drivingLicenseVice= this.licenseItem.driving_license_vice
          this.mainocr = this.licenseItem.ocr_main_extra
          this.backocr = this.licenseItem.ocr_vice_extra
          this.isregisterDate = true
          this.checkissueDate = true
          this.showmain=false
          this.showvice= false
        }
      }

      // let data = getCurrentPages()[getCurrentPages().length - 2].data
      // let isEdit = !!this.$route.query.index
      // // wx.setNavigationBarTitle({
      // //   title: isEdit ? '修改车牌' : '新增车牌'
      // // })

      // this.isEdit=isEdit,
      // this.id = isEdit ? Number(this.$route.query.id) : '',
      // this.car_no = isEdit ? Number(this.$route.query.car_no) : '',
      // this.brand = isEdit ? Number(this.$route.query.brand) : '',
      // this.vehicle_type = isEdit ? Number(this.$route.query.vehicle_type) : ''

      // this.id = isEdit ? data.licenseList[Number(this.$route.query.index)].id : '',
      // this.car_no = isEdit ? data.licenseList[Number(this.$route.query.index)].car_no : '',
      // this.brand = isEdit ? data.licenseList[Number(this.$route.query.index)].brand : '',
      // this.vehicle_type = isEdit ? data.licenseList[Number(this.$route.query.index)].vehicle_type : ''

    },
    mounted() {

    },
    methods: {
      pageReturn(){
        this.$router.go(-1)
      },
      pageToIndex(){
        this.$router.push({
          path:"/"
        })
      },
      /**
       * 防重点击
       * @param duration
       * @returns {Promise<any>}
       */
      buttonClickedFun(duration = 0) {
        this.buttonClicked = true
        return new Promise((resolve, reject) => {
          if (duration && typeof duration === 'number') {
            setTimeout(() => {
              this.buttonClicked = false
            }, duration)
          }
          resolve(true)
        })
      },
      //打开开始日期选择器弹框
      openTime() {
        this.showStartdata = true
      },
      //打开结束日期选择器弹框
      openEndTime() {
        this.showEndDate = true
      },
      //开始日期选择确认
      onConfirm(value, index) {
        let d = new Date(value)
        //let resDate = toString(d.getFullYear())  + toString((d.getMonth() + 1)) + toString(d.getDate())
        let resDate = d.getFullYear()+''+(d.getMonth() + 1)+''+d.getDate()
        this.registerDate = resDate
        this.showStartdata = false
        this.isregisterDate = true
      },
      //开始日期选择取消
      onCancel() {
        this.showStartdata = false
      },
      //结束日期选择确认
      onConfirm1(value, index) {
        let date = new Date(value)
        let endDate = date.getFullYear() +''+ (date.getMonth() + 1) +''+ date.getDate()
        this.issueDate = endDate
        this.showEndDate = false
        this.checkissueDate = true

      },
      //结束日期选择取消
      onCancel1() {
        this.showEndDate = false
      },
      //获取微信配置信息接口
      getwechat(requestData = {}) {
        httper.get("wechat/wechat/sign-package", requestData, res => {
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.appId, // 必填，公众号的唯一标识
            timestamp: res.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.nonceStr, // 必填，生成签名的随机串
            signature: res.signature, // 必填，签名
            jsApiList: ["scanQRCode"] // 必填，需要使用的JS接口列表
          });
        })
      },
      //扫描行驶证信息
      scanMesg() {
        let that = this
        wx.ready(() => {
          wx.scanQRCode({
            needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
            onlyFromCamera: true,
            scanType: ["qrCode", "barCode"],
            success: function(res) {
              if (res) {
              }
              // var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
              // window.location.href = result; //因为我这边是扫描后有个链接，然后跳转到该页面
            }
          });
        });
      },
      //行驶证正面
      getimgmain(e) {
        let that = this;
        let requestData = {}
        var files = e.target.files[0];
        if (!files) return
        let reader = new FileReader();
        reader.readAsDataURL(files); // 读取文件
        reader.onloadend = function(res) {
          that.showmain = false;
          requestData.base64_file = res.currentTarget.result;
          requestData.type = "driving"
          requestData.side = "face"
          that.request("upimg", requestData)
        }
      },
      //行驶证背面
      getimgvice(e) {
        let that = this;
        let requestData = {}
        var files = e.target.files[0];
        if (!files) return
        let reader = new FileReader();
        reader.readAsDataURL(files); // 读取文件
        reader.onloadend = function(res) {
          that.showvice = false;
          requestData.base64_file = res.currentTarget.result;
          requestData.type = "driving"
          requestData.side = "back"
          that.request("upimgvice", requestData)
        }
      },
      addCard() {
        // 防止重复点击
        this.buttonClickedFun(1000)
        let that = this
        let requestData = {}

        let car_no = this.car_no.replace(!
          /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/,
          '')
          if(this.isedit!= 0){
            requestData = {
              id: this.licenseItem.id,
              car_no: this.car_no,
              owner: this.owner,
              model: this.model,
              vin: this.vin,
              engine_no: this.engineNo,
              register_date: this.registerDate,
              issue_date: this.issueDate,
              manned_nums: this.mannedNums,
              driving_license_main: this.drivingLicenseMain,
              driving_license_vice: this.drivingLicenseVice,
              ocr_main_extra: this.mainocr,
              ocr_vice_extra: this.backocr
            }
            that.request('editCar', requestData)
          }else{
            requestData = {
              car_no: this.car_no,
              owner: this.owner,
              model: this.model,
              vin: this.vin,
              engine_no: this.engineNo,
              register_date: this.registerDate,
              issue_date: this.issueDate,
              manned_nums: this.mannedNums,
              driving_license_main: this.drivingLicenseMain,
              driving_license_vice: this.drivingLicenseVice,
              ocr_main_extra: JSON.stringify(this.mainocr),
              ocr_vice_extra: JSON.stringify(this.backocr)
            }
            that.request('addCar', requestData)
          }

        // car_no	是	string	号牌号码
        // owner	是	string	所有人
        // model	是	string	品牌车型
        // vin	是	string	车辆识别代号
        // engine_no	是	string	发动机号
        // register_date	是	string	注册日期
        // issue_date	是	string	注册日期
        // manned_nums	是	string	核定载人数
        // driving_license_main	是	string	行驶证正页
        // driving_license_vice	是	string	行驶证副页
        // extra	否	string	扩展数据
        // if (that.isEdit) {
        //   let requestData = {
        //     id: '' + that.id,
        //     car_no: car_no,
        //     brand: '' + that.brand,
        //     vehicle_type: '' + that.vehicle_type
        //   }
        //   that.request('editCar', requestData)
        // } else {
        //   let requestData = {
        //     id: '' + that.id,
        //     car_no: car_no,
        //     brand: '' + that.brand,
        //     vehicle_type: '' + that.vehicle_type
        //   }
        //   that.request('addCar', requestData)
        // }
      },

      // 调用接口
      request(type = '', requestData = {}) {
        let data = {}
        let that = this
        switch (type) {
          // 新增车信息
          case 'addCar':
            httper.post('/user/add-driving-license', requestData, res => {
              if (res.code === 0) {
                // this.$swal({text: '新增成功'})
                this.$toast({
                  message: "新增成功!",
                })
                that.$router.go(-1);
                // that.$router.push({ path: '/taoyao' })

              } else {
                this.$toast({
                  message: res.message
                })
              }
            }, true)
            break
            // 编辑车信息
          case 'editCar':
            httper.post('/user/edit-driving-license', requestData, res => {
              if (res.code === 0) {
                this.$toast({
                  message: '编辑成功'
                })
                // that.$router.push({ path: '/taoyao' })
                that.$router.go(-1);
              } else {
                this.$toast({
                  message: res.message
                })
              }
            }, true)
            break
          case 'upimg':
            httper.post('media/base64-upload', requestData, res => {
              if (res.code == 0) {
                if(!res.data.ocr){
                  Toast("请上传行驶证正面")
                  this.showmain=true
                  return
                }
                this.mainocr = res.data.ocr
                this.car_no = this.mainocr.plate_num
                this.owner = this.mainocr.owner
                this.model= this.mainocr.model
                this.vin= this.mainocr.vin
                this.engineNo= this.mainocr.engine_num
                this.registerDate= this.mainocr.register_date
                this.issueDate= this.mainocr.issue_date
                this.isregisterDate = true
                this.checkissueDate = true
                that.drivingLicenseMain = res.data.src
              } else {
                this.$toast({
                  message: res.message || '系统异常'
                })
              }

            },false)
            break
          case 'upimgvice':
            httper.post('media/base64-upload', requestData, res => {
              if (res.code == 0) {
                if(!res.data.ocr){
                  Toast("请上传行驶证背面")
                  this.showvice=true
                  return
                }
                this.backocr = res.data.ocr
                let peopleNum = (res.data.ocr.approved_passenger_capacity).split("人")
                this.mannedNums = peopleNum[0]
                that.drivingLicenseVice = res.data.src
              } else {
                this.$toast({
                  message: res.message || '系统异常'
                })
              }

            },false)
            break
        }
      }
    },
  }
</script>

<style scoped>
  .carlicenseadd_taocan {
    width: calc(100% - 40px);
    height: auto;
    /* top: 130px; */
   /* top: 19%; */
    padding: 10px;
    box-sizing: border-box;
    position: static;
    /* margin-left: 20px;
    margin-right: 20px;
    margin-top: 20px;
    margin-bottom: 15px; */
    margin: 20px;
  }

  ::-webkit-input-placeholder {
    text-align: left;
    color: rgba(187, 187, 187, 1);
    font-size: 14px;
  }

  .carlicenseadd_input1 {
    margin: 20px 20px 40px 20px;
  }

  .carlicenseadd_input {
    margin: 40px 20px;
	width: 100%;
  }

  .carlicenseadd_checktitle {
    margin-right: 10px;
    width: 30%;
  }

  .carlicenseadd_checkinput {
    width: 67%;
    font-size: 14px;
  }

  .carlicenseadd_checkinput1 {
    width: 67%;
    color: #BBBBBB;
    font-size: 14px;
  }

  .carlicenseadd_checktitle1 {
    margin-right: 54px;
  }

  .carlicenseadd_button {
    /*  margin-top: 150px; */
    width: calc(100% - 40px);
    margin: 0 20px 20px 20px;
    position: static;
    /* bottom: 10px; */
  }

  .bitian {
    color: red;
  }

  .carlicenseadd-upimgbox {
    width: calc(100% - 40px);
    margin: 0 20px 20px 20px;
    background-color: #fff;
    border-radius: 8px;
    /* height: 130px; */
    height: 220px;
    padding: 20px;
    box-sizing: border-box;
    box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3);
    /* position: absolute;
    top: 158px; */
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .carlicenseadd-upimgbox11{
    width: calc(100% - 40px);
    margin: 0 20px 20px 20px;
    margin-top: -30%;
    position: relative;
    background-color: #fff;
    border-radius: 8px;
    /* height: 130px; */
    height: 220px;
    padding: 20px;
    box-sizing: border-box;
    box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3);
    /* position: absolute;
    top: 158px; */
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .carlicenseadd-upimgbox1 {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .fileinput {
    opacity: 0;
    position: absolute;
    /* top: 0;
    left: 0;
    width: 100%;
    height: 100%; */
    cursor: pointer;
    width: 90%;
    height: 220px;
    border-radius: 24px;
  }

  .carlicenseadd-upimg {
    width: 100%;
    height: 100%;
  }

  .carlicenseadd-upimg1 {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    /* position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto; */
  }

  .carlicenseadd-none {
    width: 100%;
    /* height: 110px; */
    /* height: 232px; */
    height: 370px;
  }

  .bottonnone {
    width: 100%;
    height: 60px;
  }

  .caradd_bannerimg {
    width: calc(100% - 40px);
    margin: 20px;
    height: 40%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/xianxia/CarLicenseAdd.vue